
import { ChevronDownIcon } from 'vue-feather-icons'
import RestrictionMixin from '../../../../mixins/restrictionMixin';

export default {
  name: 'SelectField',
  components: {
    ToolTip: () => import(/* webpackChunkName: "ToolTip" */ '../../ToolTip'),
    CrownIcon: () => import(/* webpackChunkName: "Icons" */ '../../icon/CrownIcon.vue'),
    ChevronDownIcon
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['value', 'field', 'options', 'selection'],
  emits: ['input'],
  data() {
    return {
      isDropdownOpen: false,
    };
  },
  computed: {
    fullLayout() {
      return (
        this.field.customVariables &&
        this.field.customVariables.layout === "full"
      );
    },
    advancedOptionListResponsiveView() {
      return this.$store.state.store.advancedOptionListResponsiveView;
    },
    selectedOption() {
      return this.options.find((option) => option._id === this.value) || null;
    },
    fieldName() {
      return this.field.name;
    },
    isVideoCodec() {
      return ["video_codec", "video_codec_compress"].includes(this.fieldName);
    },
  },
  mixins: [RestrictionMixin],
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    selectOption({ _id, value }, event) {
      event.stopPropagation(); // prevent click event from reaching the parent
      this.$emit("input", _id);
      this.isDropdownOpen = false;

      if (this.isVideoCodec) {
        this.$store.commit("setGpuUpgradeWarning", value.endsWith("_nvenc"));
      }
    },
    checkGpuUpgradeWarning() {
      if (this.isVideoCodec) {
        this.$store.commit(
          "setGpuUpgradeWarning",
          this.selectedOption?.value.endsWith("_nvenc")
        );
      }
    },
    isProOption(item) {
      return typeof item?.value === "string" && item.value.endsWith("_nvenc");
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isDropdownOpen = false;
      }
    },
  },
  mounted() {
    this.checkGpuUpgradeWarning();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
}
